<template>
  <div>
    <!-- HEADER -->
    <div class="d-flex justify-content-between align-items-start mb-1">
      <div>
        <h4 class="font-weight-bold">Unresulted Liability</h4>
        <div class="text-muted">
          Outstanding liability on bets pending for more than 24 hours (Trading
          Team)
        </div>
      </div>

      <div>
        <b-button
          variant="primary"
          @click="handleExport"
          :disabled="loadingUnresolvedLiability"
        >
          <feather-icon icon="DownloadIcon" size="16" class="mr-1" />
          Export
        </b-button>
      </div>
    </div>

    <!-- STATS -->
    <b-card class="mb-3">
      <div>
        <b-row>
          <b-col cols="12" sm="6">
            <div class="stat-box">
              <div class="text-muted small">Stale Bets</div>
              <div class="h5 font-weight-bold">{{ metadata.total || 0 }}</div>
            </div>
          </b-col>
          <b-col cols="12" sm="6">
            <div class="stat-box">
              <div class="text-muted small">Total Liability</div>
              <div class="h5 font-weight-bold text-warning">
                {{ formatCurrencyBuiltInFunc(totalLiability || 0) }}
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- TABLE -->
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12" md="6">
            <label>Show</label>
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              class="d-inline-block mx-1"
              style="width: 100px"
            />
            <label>entries</label>
          </b-col>
          <b-col cols="12" md="6" class="text-right">
            <b-form-input
              v-model="search"
              placeholder="Search by email or bet ID..."
            />
          </b-col>
        </b-row>
      </div>

      <b-table
        :items="filteredItems"
        :fields="tableFields"
        show-empty
        responsive
        :busy="loadingUnresolvedLiability"
        thead-class="text-nowrap"
      >
        <template #cell(betId)="{ item }">
          <span>{{ item.betId }}</span>
        </template>

        <template #cell(userId)="{ item }">
          <b-link :to="{ name: 'customers-view', params: { id: item.userId } }">
            {{ item.userId }}
          </b-link>
        </template>

        <template #cell(name)="{ item }">
          {{ item.firstName }} {{ item.lastName }}
        </template>

        <template #cell(liabilityDollars)="{ item }">
          <span class="font-weight-semibold text-warning">{{
            formatCurrencyBuiltInFunc(item.liabilityDollars)
          }}</span>
        </template>

        <template #cell(betType)="{ item }">
          <b-badge>{{ item.betType }}</b-badge>
        </template>

        <template #cell(betTime)="{ item }">
          <div class="small">{{ formatDateTime(item.betTime) }}</div>
        </template>
      </b-table>

      <div class="mx-2 mb-2 mt-2" v-if="metadata.total > 0">
        <b-row>
          <b-col cols="12" sm="6">
            <span class="text-muted">
              Showing {{ (currentPage - 1) * perPage + 1 }} to
              {{ Math.min(currentPage * perPage, metadata.total) }} of
              {{ metadata.total }} entries
            </span>
          </b-col>
          <b-col cols="12" sm="6" class="d-flex justify-content-end">
            <b-pagination
              v-model="currentPage"
              :total-rows="metadata.total"
              :per-page="perPage"
              class="mb-0 mt-1 mt-sm-0"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BLink,
  BBadge,
  BFormInput,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapState } from "vuex";
import { format } from "date-fns";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BLink,
    BBadge,
    BFormInput,
    vSelect,
    BPagination,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      perPageOptions: [10, 25, 50, 100],
      search: "",
      tableFields: [
        { key: "betId", label: "Bet ID" },
        { key: "userId", label: "User ID" },
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "liabilityDollars", label: "Liability" },
        { key: "betType", label: "Type" },
        { key: "betTime", label: "Placed At" },
      ],
      metadata: { total: 0 },
    };
  },
  computed: {
    ...mapState("reporting", [
      "unresolvedLiability",
      "loadingUnresolvedLiability",
      "unresolvedLiabilityPagination",
    ]),
    filteredItems() {
      if (!this.search) return this.unresolvedLiability;
      const s = this.search.toLowerCase();
      return this.unresolvedLiability.filter(
        (item) =>
          item.email?.toLowerCase().includes(s) ||
          item.betId?.toLowerCase().includes(s) ||
          item.firstName?.toLowerCase().includes(s) ||
          item.lastName?.toLowerCase().includes(s)
      );
    },
    totalLiability() {
      console.log(this.unresolvedLiability)
      return (this.unresolvedLiability || []).reduce(
        (sum, item) => sum + (Number(item.liabilityDollars) || 0),
        0
      );
    },
  },
  watch: {
    currentPage() {
      this.fetchData();
    },
    perPage() {
      this.currentPage = 1;
      this.fetchData();
    },
    unresolvedLiabilityPagination(newVal) {
      this.metadata = newVal;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions("reporting", ["getUnresolvedLiability"]),
    formatCurrencyBuiltInFunc,
    async fetchData() {
      const data = await this.getUnresolvedLiability({
        page: this.currentPage,
        limit: this.perPage,
      });
      if (data?.pagination) {
        this.metadata = {
          total: data.pagination.total || 0,
        };
      }
    },
    formatDateTime(date) {
      return format(new Date(date), "dd/MM/yyyy HH:mm:ss");
    },
    handleExport() {
      alert("Export functionality to be implemented");
    },
  },
};
</script>

<style scoped>
.stat-box {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
}
.font-monospace {
  font-family: "Courier New", monospace;
  font-size: 0.85rem;
}
</style>
